import { GAME, ITEM_TYPES } from '../config.js';

/** Max card footprint in px (must stay in sync with lead-pop-game.css). */
export const ITEM_LAYOUT_PX = Object.freeze({
    activity: { width: 100, height: 108 },
    lead: { width: 200, height: 52 },
    backendLead: { width: 220, height: 64 },
});

const DEFAULT_BOARD = { width: 400, height: 320 };

/**
 * @param {{ type?: string, activityType?: string }} item
 */
export function resolveItemLayoutKey(item) {
    if (item?.fromBackend) {
        return 'backendLead';
    }
    if (item?.type === ITEM_TYPES.ACTIVITY_ITEM || item?.activityType) {
        return 'activity';
    }
    return 'lead';
}

/**
 * Safe center range in board % so the whole card stays inside the board.
 * @param {{ width: number, height: number }} boardSize
 * @param {'activity' | 'lead'} [layoutKey]
 */
export function getItemSafeBounds(boardSize = DEFAULT_BOARD, layoutKey = 'activity') {
    const layout = ITEM_LAYOUT_PX[layoutKey] ?? ITEM_LAYOUT_PX.activity;
    const width = boardSize.width > 0 ? boardSize.width : DEFAULT_BOARD.width;
    const height = boardSize.height > 0 ? boardSize.height : DEFAULT_BOARD.height;
    const pad = GAME.BOARD_SAFE_PADDING;

    const halfWidthPct = (layout.width / 2 / width) * 100;
    const halfHeightPct = (layout.height / 2 / height) * 100;

    const minX = pad + halfWidthPct;
    const maxX = 100 - pad - halfWidthPct;
    const minY = pad + halfHeightPct;
    const maxY = 100 - pad - halfHeightPct;

    if (minX >= maxX || minY >= maxY) {
        return { minX: 50, maxX: 50, minY: 50, maxY: 50 };
    }

    return { minX, maxX, minY, maxY };
}

/**
 * @param {{ width: number, height: number }} boardSize
 * @param {'activity' | 'lead'} layoutKey
 */
export function clampItemCenter(item, boardSize, layoutKey) {
    const { minX, maxX, minY, maxY } = getItemSafeBounds(boardSize, layoutKey);
    return {
        ...item,
        x: Math.min(maxX, Math.max(minX, item.x)),
        y: Math.min(maxY, Math.max(minY, item.y)),
    };
}
